// File: js/money/receipt-format.js
//
// Imports nothing (spec §8).
//
// Receipt numbers come from pre-allocated per-device sequential blocks (invariant 3),
// never from `Math.random()` — audit C1: `TYPE-YYYYMMDD-` + 4 random digits collides with
// 39% probability at 100 receipts/day, and the collision destroys the legitimate sale.
// This module only *renders* a number the device can already prove it owns.

/** Display width. Blocks are 1000 wide, so 6 digits covers 999,999 receipts. */
const RECEIPT_DIGITS = 6;

/**
 * Formats a receipt number for printing: zero-padded to 6 digits.
 *
 * Padding never truncates: a number wider than 6 digits is rendered in full. A receipt
 * number is a document identity, and silently shortening it would print a number that
 * points at a different sale — the exact confusion the paper carnet must never contain.
 *
 * @param {number} n Non-negative integer receipt number.
 * @returns {string} e.g. `1` → `'000001'`, `1234567` → `'1234567'`.
 * @throws {RangeError} If `n` is not a non-negative integer (programmer error: an
 *   unallocated or malformed number must never reach the printer).
 */
export function formatReceiptNo(n) {
    if (!Number.isInteger(n) || n < 0) {
        throw new RangeError(`formatReceiptNo expects a non-negative integer, received ${String(n)}`);
    }
    return String(n).padStart(RECEIPT_DIGITS, '0');
}
